import analytics from '@xto10x/core/lib/analytics';
import { ToastActionType, AlertActionTypes } from 'utils/constants';
import { showNewVersionAvailableAlertMessage } from '../store/actions';

const AppVersionValidator = {
  validateAppVersion: (isNewAppVersionAvailable, dispatch) => {
    try {
      if (isNewAppVersionAvailable) {
        const alertAction = {
          actionText: 'Refresh',
          actionType: ToastActionType.UPDATE_WITH_NEW_VERSION,
          showButton: true,
          imageUrl: '/assets/images/refresh-white.svg'
        };
        // new action for this alert so that this alert doesn't go away even after we get other alerts
        dispatch(
          showNewVersionAvailableAlertMessage(
            AlertActionTypes.NO_ICON,
            'New update is available. Kindly refresh',
            alertAction
          )
        );
        analytics.trackEvent(
          'validateAppVersion',
          'showing manual update toast'
        );
      }
    } catch (e) {
      analytics.trackError('validate_app_version', e);
    }
  }
};

export default AppVersionValidator;

export const validateAppVersion = (isNewAppVersionAvailable, dispatch) => {
  AppVersionValidator.validateAppVersion(isNewAppVersionAvailable, dispatch);
};
